import React from "react";
import { Box, Grow, Link, Typography } from "@mui/material";

function BDay40() {
  return (
    <Box>
      <Box
        width={1}
        display="flex"
        align="center"
        style={{
          backgroundImage: `url('/assets/video.gif')`,
          backgroundSize: "cover",
          height: "100vh",
        }}
        flexDirection="column"
      >
        <Box
          mt={5}
          px={{
            xs: 1,
          }}
        >
          <Grow in={true} timeout={1000}>
            <Typography sx={{ fontSize: { xs: "2rem", md: "3rem" } }} paragraph>
              <strong>Thank you for sharing a great time with me!</strong>
            </Typography>
          </Grow>
          <Grow in={true} timeout={1300}>
            <Typography variant="h5">
              See all the pictures{" "}
              <Link
                href="https://photos.app.goo.gl/jvz42LquvZ6P2zvq5"
                target="_blank"
              >
                here!
              </Link>
            </Typography>
          </Grow>
        </Box>
        <Box>
          <audio controls={false} autoPlay loop id="music">
            <source src="assets/music.mp3" type="audio/mp3" />
          </audio>
        </Box>
      </Box>
    </Box>
  );
}

export default BDay40;
